import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import GridSection from "./components/GridSection";
import CategoryScroll from "./components/CategoryScroll";
import CTASection from "./components/CTASection";
import SEOArticlesSection from "./components/SEOArticlesSection";
import TestimonialSection from "./components/TestimonialSection";
import FooterSection from "./components/FooterSection";

const siteUrl = 'https://cssbuy.team';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CSSBuy.Team",
  "url": siteUrl,
  "description": "A CSSBuy Spreadsheet mais completa e atualizada de 2026. Encontre sneakers, roupas, acessórios e os produtos mais comprados da China com envio para Brasil e Portugal.",
  "inLanguage": "pt-BR",
  "publisher": {
    "@type": "Organization",
    "name": "CSSBuy.Team",
    "url": siteUrl,
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png"
    }
  }
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <GridSection />
      <CategoryScroll />
      <CTASection />
      <SEOArticlesSection />
      <TestimonialSection />
      <FooterSection />
    </main>
  );
}